var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExercise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6452 7.51514C20.6452 7.29011 20.7372 7.07429 20.901 6.91517C21.0648 6.75605 21.287 6.66666 21.5186 6.66666H25.0124C25.2441 6.66666 25.4662 6.75605 25.63 6.91517C25.7938 7.07429 25.8859 7.29011 25.8859 7.51514V9.21211H28.5062C28.7379 9.21211 28.96 9.3015 29.1238 9.46063C29.2876 9.61975 29.3797 9.83556 29.3797 10.0606V15.1515H32V16.8485H29.3797V21.9394C29.3797 22.1644 29.2876 22.3802 29.1238 22.5394C28.96 22.6985 28.7379 22.7879 28.5062 22.7879H25.8859V24.4848C25.8859 24.7099 25.7938 24.9257 25.63 25.0848C25.4662 25.2439 25.2441 25.3333 25.0124 25.3333H21.5186C21.287 25.3333 21.0648 25.2439 20.901 25.0848C20.7372 24.9257 20.6452 24.7099 20.6452 24.4848V16.8485H11.3548V24.4848C11.3548 24.7099 11.2628 24.9257 11.099 25.0848C10.9352 25.2439 10.713 25.3333 10.4814 25.3333H6.98759C6.75594 25.3333 6.53377 25.2439 6.36997 25.0848C6.20617 24.9257 6.11414 24.7099 6.11414 24.4848V22.7879H3.4938C3.26214 22.7879 3.03998 22.6985 2.87617 22.5394C2.71237 22.3802 2.62035 22.1644 2.62035 21.9394V16.8485H0V15.1515H2.62035V10.0606C2.62035 9.83556 2.71237 9.61975 2.87617 9.46063C3.03998 9.3015 3.26214 9.21211 3.4938 9.21211H6.11414V7.51514C6.11414 7.29011 6.20617 7.07429 6.36997 6.91517C6.53377 6.75605 6.75594 6.66666 6.98759 6.66666H10.4814C10.713 6.66666 10.9352 6.75605 11.099 6.91517C11.2628 7.07429 11.3548 7.29011 11.3548 7.51514V15.1515H20.6452V7.51514ZM7.86104 23.6364H9.60794V8.36363H7.86104V23.6364ZM6.11414 10.9091H4.36725V21.0909H6.11414V10.9091ZM25.8859 21.0909V10.9091H27.6328V21.0909H25.8859ZM24.139 8.36363V23.6364H22.3921V8.36363H24.139Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#027bff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/Exercise.c8832090749a1ead09d7f9389856666b.svg";
export { ForwardRef as ReactComponent };